import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import { withValidation, validationPropTypes } from 'gw-portals-validation-react';
import { withViewModelService, ViewModelForm } from 'gw-portals-viewmodel-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { ServiceManager } from '@jutro/services';
import messages from './SearchContactComponent.messages'
import styles from './SearchContactComponent.module.scss';
import metadata from './SearchContactComponent.metadata.json5';
import { Button } from '@jutro/components';

const ACCOUNT_TYPE = {
    commercial: 'Company',
    personal: 'Person'
};

class SearchContact extends Component {
    static contextType = TranslatorContext

    localeService = ServiceManager.getService('locale-service');

    state = {
        contactVM: {},
        existingSearchResult: [],
        searchResult: false,
        noResult: false,
        newContact: false
    };

    static propTypes = {
        viewModelService: PropTypes.shape({
            create: PropTypes.func
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func
        }).isRequired,
        accountNumber: PropTypes.string.isRequired,
        relatedTo: PropTypes.string.isRequired,
        authHeader: PropTypes.shape({}).isRequired
    };

    createVM = (model) => {
        const { viewModelService } = this.props;
        return viewModelService.create(
            model,
            'pc',
            'edge.capabilities.quote.submission.base.dto.AdditionalNamedinsuredSearchDTO'
        );
    };

    showValidations = (value) => {

    };

    searchContacts = async () => {
        const { authHeader } = this.props;
        const { contactVM } = this.state;
        let { existingSearchResult, searchResult, noResult } = this.state;
        const contacts = await LoadSaveService.searchExistingContactRecords([contactVM.value], authHeader);
        if (contacts && contacts.length > 0) {
            existingSearchResult = contacts;
            searchResult = true;
            noResult = false;
        } else {
            existingSearchResult = contacts;
            searchResult = true;
            noResult = true;
        }

        this.setState({
            searchResult,
            existingSearchResult,
            noResult
        });
    };

    cancelSearch = () => {
        const { handleCancel } = this.props;
        let { newContact } = this.state;
        newContact = false;
        this.setState({ newContact });
        handleCancel();
    }

    componentDidMount = () => {
        let { contactVM } = this.state;
        const model = {
            subtype: ACCOUNT_TYPE.personal
        };
        contactVM = this.createVM(model);
        this.setState({
            contactVM
        });
    };

    writeValue = (value, path) => {
        const { contactVM } = this.state;
        _.set(contactVM, path, value);
        this.setState({ contactVM });
    };

    addExistingAccountContact = async (data) => {
        const { accountNumber, updateContacts, authHeader, viewModelService } = this.props;
        const { existingSearchResult } = this.state;
        const value = existingSearchResult.find(el => el.publicID === data.publicID);
        const contact = await LoadSaveService.createNewAccountContact(value, accountNumber.value, authHeader);
        updateContacts(contact);
    };

    addContactCell = (item, index) => {
        return <Button id={'addContact' + index} onClick={() => { this.addExistingAccountContact(item) }} > Add </Button>
    };

    getCell = (item, index, { path: prop }) => {
        return _.get(item, prop);
    };

    getSearchDisabled = () => {
        const { contactVM } = this.state;
        if (contactVM.subtype && contactVM.subtype.value == ACCOUNT_TYPE.commercial) {
            return !contactVM.contactName.value
        }
        else if (contactVM.subtype && contactVM.subtype.value == ACCOUNT_TYPE.personal) {
            return (!contactVM.firstName.value || !contactVM.lastName.value)
        }
        return true;
    };

    render() {
        const {
            contactVM,
            existingSearchResult,
            searchResult,
            noResult,
            newContact
        } = this.state;

        const { handleAddNew } = this.props;

        const subtype = _.get(contactVM, `${'subtype'}.value`);
        const overrideProps = {
            '@field': {
                labelPosition: 'left'
            },
            commercialContactContainer: {
                visible: subtype === ACCOUNT_TYPE.commercial
            },
            personalContactContainer: {
                visible: subtype === ACCOUNT_TYPE.personal
            },
            exisitingContactsTable: {
                data: existingSearchResult
            },
            existingContactSearchResult: {
                visible: searchResult
            },
            noContactMatch: {
                visible: noResult
            },
            addNewContainer: {
                visible: newContact
            },
            addBtn: {
                visible: noResult
            },
            searchBtn: {
                disabled: this.getSearchDisabled(),
                content: searchResult ? "Search Again" : "Search"
            },
            cancelBtn: {
                onClick: this.cancelSearch
            },
            addContactsContainer: {
                visible: !newContact
            }
        };

        const resolvers = {
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                onSearchContacts: this.searchContacts,
                onCancel: this.cancelSearch,
                onAddNew: handleAddNew,
                getCell: this.getCell,
                addContactCell: this.addContactCell
            },
            resolveComponentMap: {
            }
        };

        return (
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={contactVM}
                overrideProps={overrideProps}
                onValueChange={this.writeValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        );
    }
}
export const SearchContactComponent = SearchContact;
export default withValidation(
    withViewModelService(withAuthenticationContext(SearchContact))
);
